import store from '@/utils/store'
export const columns = (vm) => {
    return [
        {
            type: 'index',
            minWidth: 60,
            label: '序号',
            align: 'center',
            headerAlign: 'center',
        },
        {
            label: '设备名称',
            prop: 'deviceName',
            align: 'left',
            headerAlign: 'left',
            minWidth: 130
        },
        {
            label: '设备序列号',
            prop: 'serialNo',
            align: 'left',
            headerAlign: 'left',
            minWidth: 130
        },
        {
            label: '项目名称',
            prop: 'projectName',
            align: 'left',
            headerAlign: 'left',
            minWidth: 130
        },
        {
            label: '项目省市区',
            prop: 'projectAreaAddress',
            align: 'left',
            headerAlign: 'left',
            minWidth: 130
        },
        {
            label: '项目地址',
            prop: 'projectAddress',
            align: 'left',
            headerAlign: 'left',
            minWidth: 130
        },
        {
            label: '报警地址',
            prop: 'policeAddress',
            align: 'left',
            headerAlign: 'left',
            minWidth: 130
        },
        {
            label: '报警消息',
            prop: 'message',
            align: 'center',
            headerAlign: 'center',
            minWidth: 130
        },
        {
            label: '区域位置',
            prop: 'policeAddress',
            align: 'left',
            headerAlign: 'left',
            minWidth: 130
        },
        {
            label:'设备状态',
            prop:'state',
            align: 'center',
            headerAlign: 'center',
            render: (h, params) => {
                let txt = '';
                if(params.row.state == 0){
                    txt = '未处理'
                }else if(params.row.state == 1){
                    txt = '已处理'
                }
                return h('span',{},txt)
            }
        },
        {
            label: '报警时间',
            prop: 'policeTime',
            align: 'left',
            headerAlign: 'left',
            minWidth: 130
        },
        {
            label: '处理时间',
            prop: 'processTime',
            align: 'left',
            headerAlign: 'left',
            minWidth: 130
        },
    ]
}